var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form-item",
    { attrs: { label: _vm.i18nt("designer.setting.colPullTitle") } },
    [
      _c("el-input-number", {
        staticStyle: { width: "100%" },
        attrs: { min: 0, max: 24 },
        model: {
          value: _vm.optionModel.pull,
          callback: function ($$v) {
            _vm.$set(_vm.optionModel, "pull", _vm._n($$v))
          },
          expression: "optionModel.pull",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }